/* this file added by Bearer Web Developer  */

import { observer } from 'mobx-react-lite';
import BearerTextField from '../../../../components/fields/BearerTextField';
import { useAppState } from '../../../../states/app-state';
import styles from './information.module.scss';
import RightRadioButton from '../../../../components/rightradiobutton/RightRadioButton';
import { ApprovalMethodEnum } from '../../../../states/reservedOrdersState/models/editOrderApiIntegration';
import { RecipientName, RecipientPhoneNumberCode, RecipientPhoneNumberPhoto } from '../validateForm';
import { useThemeMode } from '../../../../states/contexts/theme';

const EditInformation: React.FC = observer(() => {
    const appState = useAppState();
    const { activeManageOrder, setEditOrderApiIntegrationData } = appState?.ReservedOrders;
    const editData = appState?.ReservedOrders.editOrderApiIntegrationData;
    const RecipientPhoneNumber =
        editData?.dropoff_verification_method === "Code" ? RecipientPhoneNumberCode : RecipientPhoneNumberPhoto;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.information} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <ul>
                <li>
                    {
                        theme === 'dark' ? <img src="/person-white.svg" alt="" width={21} height={21} />
                            : <img src="/person-black.webp" alt="" width={21} height={21} />
                    }
                    <div className={styles.recipient_name_input}>
                        <BearerTextField
                            colorStyle='gray'
                            placeholder={"Recipient’s Name"}
                            label="Recipient’s Name:"
                            inputSmallStyle={true}
                            value={editData.recipient_name}
                            onChange={(e) => setEditOrderApiIntegrationData({ recipient_name: e.target.value })}
                            clear={() => { setEditOrderApiIntegrationData({ recipient_name: '' }) }}
                            validator={RecipientName}
                        />
                    </div>
                </li>
                <li>
                    {
                        theme === 'dark' ? <img src="/call-white.svg" alt="" width={21} height={21} />
                            : <img src="/call-grey.webp" alt="" width={21} height={21} />
                    }
                    <div className={styles.recipient_number_input}>
                        <BearerTextField
                            colorStyle='gray'
                            placeholder={"Recipient’s Number"}
                            label="Recipient’s Number:"
                            inputSmallStyle={true}
                            value={editData.recipient_phone_number}
                            onChange={(e) => {
                                const value = e.target.value?.replace(/\s+/g, "").slice(0, 12); // This replace removes every whitespace character
                                const beginningNumber = editData?.dropoff_verification_method === ApprovalMethodEnum.Code ? 4 : 3;
                                const beginning = editData?.dropoff_verification_method === ApprovalMethodEnum.Code ? "+614" : "+61";
                                const text = value.slice(0, beginningNumber) !== beginning ? beginning + value.slice(beginningNumber) : value;
                                setEditOrderApiIntegrationData({ recipient_phone_number: text });
                            }}
                            clear={() => {
                                const beginning = editData?.dropoff_verification_method === ApprovalMethodEnum.Code ? "+614" : "+61";
                                setEditOrderApiIntegrationData({ recipient_phone_number: beginning })
                            }}
                            validator={RecipientPhoneNumber}
                        />
                    </div>
                </li>
                <li>
                    {
                        theme === 'dark' ? <img src="/orders-white.svg" alt="" width={21} height={21} />
                            : <img src="/orders-grey.webp" alt="" width={21} height={21} />
                    }
                    <div>
                        <div>Drop off Method:</div>
                        <div>
                            <RightRadioButton
                                gray={true}
                                label="6-digit code"
                                checked={editData?.dropoff_verification_method === ApprovalMethodEnum.Code}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setEditOrderApiIntegrationData({
                                            dropoff_verification_method: ApprovalMethodEnum.Code
                                        });
                                        setEditOrderApiIntegrationData({ recipient_phone_number: "+614" });
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <RightRadioButton
                                gray={true}
                                label="Photo at destination"
                                checked={editData?.dropoff_verification_method === ApprovalMethodEnum.Photo}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setEditOrderApiIntegrationData({
                                            dropoff_verification_method: ApprovalMethodEnum.Photo
                                        });
                                        setEditOrderApiIntegrationData({ recipient_phone_number: "+61" });
                                    }
                                }}
                            />
                        </div>
                    </div>
                </li>
                <li className={styles.parcel_weight}>
                    {
                        theme === 'dark' ? <img src="/weight-white.svg" alt="" width={21} height={21} />
                            : <img src="/weight-grey.webp" alt="" width={21} height={21} />
                    }
                    Parcel Weight:<br />{`${activeManageOrder?.parcel_min_weight} ~ ${activeManageOrder?.parcel_max_weight} KG`}
                </li>
            </ul>
        </div>
    )
})
export default EditInformation;